import { getAssets, swalError, swalSuccess } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { Field, Form, Formik } from "formik";
import Image from "next/legacy/image";
import { useState } from "react";
import * as Yup from "yup";
import styles from "./forgot_password.module.scss";

import { CircularProgress } from "@mui/material";
import { useRouter } from "next/router";

export const ForgPassword = () => {
  const router = useRouter();
  const { passResetToken, userTypeSlug } = router.query;
  const [laoding, setLoading] = useState();

  const [email, setEmail] = useState("");
  const validationSchema = Yup.object().shape({
    password:
      passResetToken && userTypeSlug
        ? Yup.string()
            .min(6, "Must be more than or equal 6 characters")
            .required("Password is required")
            .matches(
              /^(?=.*[0-9])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{6,}$/,
              "Must Contain 6 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
            )
        : Yup.string(),
    passwordConfirm:
      passResetToken && userTypeSlug
        ? Yup.string().oneOf(
            [Yup.ref("password"), null],
            "Passwords must match"
          )
        : Yup.string(),
    email:
      passResetToken && userTypeSlug
        ? Yup.string().nullable()
        : Yup.string()
            .email("Field is required")
            .typeError("Wrong email format")
            .required("Field is required"),
  });

  const handleForgot = async (values, action) => {
    setLoading(true);
    if (passResetToken && userTypeSlug) {
      await API.post("/auth/change-forgot-pass", {
        passResetToken: passResetToken,
        userTypeSlug: "student",
        password: values.password,
        passwordConfirm: values.passwordConfirm,
      })
        .then((res) => {
          if (!res.error && res.statusCode === 201) {
            swalSuccess("Password Reset Succesfully");
            router.push("/");
            setLoading(false);
            return true;
          } else {
            swalError(res.message);
          }
        })
        .catch((error) => {
          setLoading(false);
          return false;
        });
    } else {
      await API.post("/auth/forgot-password", {
        email: values.email,
        userTypeSlug: "student",
      })
        .then((res) => {
          if (!res.error && res.statusCode === 201) {
            return router.push({
              pathname: "/forgot-password/email-notify",
              query: { email, userTypeSlug: "student" },
            });
          } else {
            swalError(res.message);
          }
        })
        .catch((error) => {
          setLoading(false);
          return false;
        });
    }
    setLoading(false);
    return false;
  };
  const passwordInit = {
    password: "",
    passwordConfirm: "",
    email: "",
  };

  return (
    <section className={styles.section_auth}>
      <div className={styles.side_bg}></div>

      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.left_wrapper}>
            <div className={styles.logo_and_title_wrapper}>
              <Image
                src={getAssets("assets/logo-beta.webp")}
                alt="UniSearch Logo"
                blurDataURL={getAssets("assets/logo-beta.webp")}
                placeholder="blur"
                width={186}
                height={30}
              />
              <div className={styles.title}>
                Discover study abroad opportunities around the world with
                UniSearch
              </div>
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets(
                  "assets/images/auth/illustration_forget_password.png"
                )}
                alt="singin"
              />
            </div>
          </div>

          <div className={styles.right_wrapper}>
            <div className={styles.form_title_wrapper}>
              {passResetToken && userTypeSlug ? (
                <div className={styles.form_title}>Set Your New Password?</div>
              ) : (
                <div className={styles.form_title}>Forgot Your Password?</div>
              )}
              {/* <div className={styles.form_sub_title}>
                Please enter your phone number or email address, and we will
                send you a 4-digit code for veritification
              </div> */}
            </div>

            <div className={styles.form_wrapper}>
              <Formik
                initialValues={passwordInit}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={(values, action) => {
                  handleForgot(values, action);
                }}
              >
                {({
                  handleSubmit,
                  setFieldValue,
                  values,
                  errors,
                  touched,
                  resetForm,
                  handleBlur,
                  handleChange,
                }) => (
                  <Form>
                    {passResetToken && userTypeSlug ? (
                      <>
                        <div className={styles.form_group}>
                          <label>New Password</label>
                          <Field
                            placeholder="Password"
                            name="password"
                            type="password"
                            value={values?.password || ""}
                            onChange={(e) => {
                              setFieldValue("password", e.target.value);
                            }}
                          />
                          {errors.password && touched.password ? (
                            <div className="invalid-feedback">
                              {errors.password}
                            </div>
                          ) : null}
                        </div>
                        <div className={styles.form_group}>
                          <label>Confirm Password</label>
                          <Field
                            placeholder="Confirm Password"
                            name="passwordConfirm"
                            type="password"
                            value={values?.passwordConfirm || ""}
                            onChange={(e) => {
                              setFieldValue("passwordConfirm", e.target.value);
                            }}
                          />
                          {errors.passwordConfirm && touched.passwordConfirm ? (
                            <div className="invalid-feedback">
                              {errors.passwordConfirm}
                            </div>
                          ) : null}
                        </div>
                      </>
                    ) : (
                      <div className={styles.form_group}>
                        <label>Email Address</label>
                        <Field
                          placeholder="Email Address or Phone Number"
                          name="email"
                          type="email"
                          value={values?.email || ""}
                          onChange={(e) => {
                            setFieldValue("email", e.target.value);
                            setEmail(e.target.value);
                          }}
                        />
                        {errors.email && touched.email ? (
                          <div className="invalid-feedback">{errors.email}</div>
                        ) : null}
                      </div>
                    )}

                    <div className={styles.btn_group_wrapper}>
                      <button
                        className="btn btn-bg btn-secondary"
                        onClick={() => {
                          handleSubmit();
                        }}
                        type="button"
                        disabled={laoding}
                      >
                        {laoding && (
                          <CircularProgress size={25} color="inherit" />
                        )}{" "}
                        {passResetToken && userTypeSlug ? "Save" : "Next"}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgPassword;
